export const Hero = () => {
    const handleCta = () => {
        const el = document.getElementById("packages");
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    // Soft, layered indigo halo — no visible plate, just enough to lift text from the
    // illustration without darkening it.
    const haloHeading = {
        textShadow:
            "0 1px 2px rgba(27,42,65,0.55), 0 4px 14px rgba(27,42,65,0.5), 0 10px 32px rgba(27,42,65,0.45)",
    };
    const haloBody = {
        textShadow:
            "0 1px 2px rgba(27,42,65,0.55), 0 2px 8px rgba(27,42,65,0.55), 0 6px 20px rgba(27,42,65,0.4)",
    };
    const haloCaption = {
        textShadow: "0 1px 2px rgba(27,42,65,0.6)",
    };

    return (
        <section
            id="hero"
            data-testid="hero-section"
            className="relative min-h-[100svh] w-full overflow-hidden bg-[#1B2A41]"
        >
            {/* Full-bleed editorial illustration */}
            <img
                src="/img/hero-v3.png"
                alt="Внутри — операционная система для собственников ИТ"
                data-testid="hero-image"
                className="absolute inset-0 w-full h-full object-cover object-center select-none pointer-events-none"
                draggable="false"
            />

            {/* Mobile-only safety wash so headline still reads against the same image
                cropped tight; on lg+ we keep the illustration fully clean. */}
            <div
                aria-hidden="true"
                className="absolute inset-0 bg-[#1B2A41]/35 lg:hidden"
            />

            {/* Top hairline */}
            <div
                aria-hidden="true"
                className="absolute top-20 left-0 right-0 h-px bg-[#F4F1EA]/15"
            />

            {/* Content */}
            <div className="relative z-10 max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 min-h-[100svh] flex flex-col justify-between pt-32 sm:pt-36 pb-12">
                {/* Upper: headline floating directly on the illustration */}
                <div className="grid lg:grid-cols-12 gap-10 pt-6 sm:pt-10">
                    <div className="lg:col-span-8 xl:col-span-7 max-w-3xl">
                        <h1
                            data-testid="hero-title"
                            className="text-[36px] sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.04] tracking-[-0.025em] font-light text-[#F4F1EA]"
                            style={haloHeading}
                        >
                            Я превращаю{" "}
                            <span className="relative inline-block font-semibold">
                                хаос
                                <span
                                    className="absolute left-0 right-0 -bottom-1 sm:-bottom-2 h-[3px] sm:h-[4px] bg-[#C46342]"
                                    style={{
                                        boxShadow:
                                            "0 1px 2px rgba(27,42,65,0.5)",
                                    }}
                                />
                            </span>{" "}
                            в&nbsp;ИТ‑разработке в&nbsp;
                            <span className="font-semibold">понятный</span> и&nbsp;
                            <span className="font-semibold text-[#C46342]">
                                управляемый
                            </span>{" "}
                            процесс
                        </h1>
                    </div>
                </div>

                {/* Mid filler — pushes CTAs / stats block down */}
                <div className="flex-1" />

                {/* Lower: cta + stats — also floating directly on the illustration */}
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
                    <div className="lg:col-span-6 xl:col-span-6">
                        <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
                            <button
                                data-testid="hero-cta-button"
                                onClick={handleCta}
                                className="group inline-flex items-center justify-center gap-3 bg-[#C46342] hover:bg-[#8f4631] text-[#F4F1EA] px-9 py-5 text-[11px] font-semibold tracking-[0.28em] uppercase transition-colors shadow-[0_8px_22px_-10px_rgba(27,42,65,0.7)]"
                            >
                                Найти свой формат
                                <svg
                                    width="20"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    className="transition-transform group-hover:translate-x-1.5"
                                >
                                    <path
                                        d="M1 6H17M17 6L12 1M17 6L12 11"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                    />
                                </svg>
                            </button>

                            <a
                                href="https://t.me/ekulakova1"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="hero-telegram-link"
                                className="inline-flex items-center justify-center gap-2 px-4 py-5 text-[11px] font-semibold tracking-[0.28em] uppercase text-[#F4F1EA] hover:text-[#C46342] transition-colors"
                                style={haloCaption}
                            >
                                <span className="vnutri-link">
                                    Написать в Telegram
                                </span>
                                <span className="text-[#C46342]">↗</span>
                            </a>
                        </div>
                    </div>

                    <div className="lg:col-span-6" aria-hidden="true" />
                </div>

            </div>
        </section>
    );
};
